module.exports = __webpack_public_path__ + "img/360int.b90bd9c1.svg";